import React from "react";
import { Check } from "lucide-react";

import PentatonicLogo from "../../assets/Pentatonic_Logo.svg";
import BackgroundShapes from "../ui-new/BackgroundShapes";

import AuthComponent from "./AuthComponent";

export default function Login() {
  return (
    <div className="min-h-screen relative overflow-hidden bg-penta-grey-light">
      <BackgroundShapes />

      {/* Desktop and tablet layout */}
      <div className="hidden lg:flex w-full h-screen font-sans font-light">
        {/* Center modal */}
        <div className="w-full flex items-center justify-center relative z-20">
          <div className="sign-in-modal bg-white p-10 w-full max-w-md mx-4 relative border border-neutral-200">
            <div>
              <div className="flex justify-center mb-8">
                <img
                  src={PentatonicLogo}
                  alt="Pentatonic"
                  className="h-7 w-auto"
                />
              </div>
              <h2 className="text-3xl font-light text-center text-penta-black">
                Welcome to Pentatonic
              </h2>
              <p className="text-base font-light mb-10 text-center text-penta-grey-medium">
                Sign up to unlock the full experience
              </p>
              <ul className="space-y-5 text-penta-black mb-10 font-light">
                <li className="flex items-start">
                  <span className="mr-3 w-6 h-6 flex items-center justify-center shrink-0 text-penta-mint">
                    <Check className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                  <span>
                    Create unlimited chats, finding your ideal match from
                    millions of products with the power of AI
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 w-6 h-6 flex items-center justify-center shrink-0 text-penta-mint">
                    <Check className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                  <span>
                    Train Pentatonic to understand your unique preferences,
                    tastes, and budget
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 w-6 h-6 flex items-center justify-center shrink-0 text-penta-mint">
                    <Check className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                  <span>Benefit from new features to be launched soon</span>
                </li>
              </ul>
              <AuthComponent />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile layout */}
      <div className="lg:hidden flex flex-col min-h-screen">
        {/* Centered sign up modal */}
        <div className="flex-1 flex items-center justify-center relative z-20 mx-4 mt-[10vh]">
          <div className="sign-in-modal bg-white p-6 w-full max-w-md mx-auto relative border border-neutral-200">
            <div>
              <div className="flex justify-center mb-6">
                <img
                  src={PentatonicLogo}
                  alt="Pentatonic"
                  className="h-5 w-auto"
                />
              </div>
              <h2 className="text-2xl font-light text-center text-penta-black">
                Welcome to Pentatonic
              </h2>
              <p className="text-base font-light mb-10 text-center text-penta-grey-medium">
                Sign up to unlock the full experience
              </p>
              <ul className="space-y-4 text-penta-black mb-8 text-sm font-light">
                <li className="flex items-start">
                  <span className="mr-3 w-5 h-5 flex items-center justify-center shrink-0 text-penta-mint">
                    <Check className="h-4 w-4" strokeWidth={1.5} />
                  </span>
                  <span>
                    Create unlimited chats, finding your ideal match from
                    millions of products with the power of AI
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 w-5 h-5 flex items-center justify-center shrink-0 text-penta-mint">
                    <Check className="h-4 w-4" strokeWidth={1.5} />
                  </span>
                  <span>
                    Train Pentatonic to understand your unique preferences,
                    tastes, and budget
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 w-5 h-5 flex items-center justify-center shrink-0 text-penta-mint">
                    <Check className="h-4 w-4" strokeWidth={1.5} />
                  </span>
                  <span>Benefit from new features to be launched soon</span>
                </li>
              </ul>
              <AuthComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
